module.exports = __webpack_public_path__ + "img/31-l.f8eb6c07.png";